import React from 'react';
import { Link } from 'react-router-dom';
import { Sprout, Copy } from 'lucide-react';

import Button from '../ui/Button';
import { useCart } from '../../context/CartContext';
import { useToast } from '../ui/Toast';
import { formatPrice } from '../../utils/money';
import { primaryPhoto } from '../../utils/photos';
import { cloudinaryThumb, cloudinaryThumbSrcSet } from '../../utils/cloudinary';

export default function ProductCard({ product }) {
  const { addItem } = useCart();
  const { addToast } = useToast();
  const id = product._id || product.id;
  const photo = primaryPhoto(product.photos);
  const depositRequired = (product.category?.depositPercent || 0) > 0;
  const localPickupOnly = !!product.category?.localPickupOnly;

  const addToCart = () => {
    addItem(product, 1);
  };

  const copyLink = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    const url = `${window.location.origin}/products/${id}`;
    try {
      await navigator.clipboard.writeText(url);
      addToast('Link copied!', { variant: 'success' });
    } catch {
      addToast('Could not copy link', { variant: 'error' });
    }
  };

  return (
    <article className="ss-product-card ss-card">
      {depositRequired && (
        <span className="ss-product-card__ribbon ss-product-card__ribbon--deposit">Deposit required</span>
      )}
      {localPickupOnly && (
        <span className="ss-product-card__ribbon ss-product-card__ribbon--pickup">Local pickup only</span>
      )}
      <button
        type="button"
        className="ss-product-card__copy-btn"
        onClick={copyLink}
        aria-label="Copy product link"
        title="Copy product link"
      >
        <Copy size={16} aria-hidden="true" />
      </button>
      <Link to={`/products/${id}`} className="ss-product-card__link">
        <div className="ss-product-card__media">
          {photo ? (
            <img
              src={cloudinaryThumb(photo.url, 300)}
              srcSet={cloudinaryThumbSrcSet(photo.url, 300)}
              alt={product.title}
              loading="lazy"
            />
          ) : (
            <span className="ss-media-empty">
              <Sprout size={48} aria-hidden="true" />
            </span>
          )}
        </div>
        <div className="ss-product-card__body-top">
          <span className="ss-product-card__title">{product.title}</span>
          {product.category?.name && (
            <span className="ss-product-card__cat">{product.category.name}</span>
          )}
        </div>
      </Link>
      <div className="ss-product-card__foot">
        <span className="ss-price">{formatPrice(product.price)}</span>
        <Button size="sm" onClick={addToCart}>Add</Button>
      </div>
    </article>
  );
}
